import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  createStaticRanges,
  defaultStaticRanges,
} from 'react-date-range';
import moment from 'moment';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import {
  PopupDatePicker,
  SelectField,
  ConainerText,
  IconCalendar,
  Text,
  DateRangePickerPopup,
} from './styles';

const FORMAT = 'MMM, DD yyyy';

// Add All Time as a default filter option
const staticRanges = [
  ...defaultStaticRanges,
  ...createStaticRanges([
    {
      label: 'All Time',
      range: () => ({
        startDate: null,
        endDate: null,
      }),
    },
  ]),
];

const DateRangePicker = (props) => {
  const {
    onChange,
    rangeDate,
    placeholder,
  } = props;

  const [isOpen, setOpen] = useState(false);

  const isEndDateSet = rangeDate.endDate;

  const handleChange = (change) => {
    onChange(change.selection);
    setOpen(false);
  };

  return (
    <PopupDatePicker
      basic
      open={isOpen}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      content={(
        <DateRangePickerPopup
          editableDateInputs
          onChange={handleChange}
          moveRangeOnFirstSelection={false}
          ranges={[rangeDate]}
          maxDate={new Date()}
          staticRanges={staticRanges}
          startDatePlaceholder="Start Date"
          endDatePlaceholder="End Date"
          inputRanges={[]}
        />
      )}
      on="click"
      positionFixed
      position="bottom center"
      trigger={(
        <SelectField>
          <ConainerText>

            <IconCalendar name="calendar alternate outline" />

            {!isEndDateSet && <Text>{placeholder}</Text>}

            {isEndDateSet
            && (
              <Text nomargin>
                {`${moment(rangeDate.startDate).format(FORMAT)} - ${moment(rangeDate.endDate).format(FORMAT)}`}
              </Text>
            )}
          </ConainerText>
        </SelectField>
      )}
    />
  );
};

DateRangePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  rangeDate: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    key: PropTypes.string,
  }),
  placeholder: PropTypes.string.isRequired,
};

DateRangePicker.defaultProps = {
  rangeDate: PropTypes.shape({
    startDate: null,
    endDate: null,
    key: 'selection',
  }).isRequired,
};

export default DateRangePicker;
